import { JOB_SOURCES } from '@chukua/common';
import { DatePicker, Form, Input, InputNumber, Select } from 'antd';
import { JOB_SOURCE_LABELS } from './job-source-labels';
import type { Zone } from '../reference-data/reference-data.api';

/** Everything fillable now or later — source, who asked, quantity, zones, dates — shared shape by JobIntakeForm, kept out of it to stay under the line limit. */
export function JobIntakeDetailFields({ zones }: { zones: Zone[] }) {
  return (
    <>
      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="source" label="Source">
          <Select allowClear options={JOB_SOURCES.map((source) => ({ value: source, label: JOB_SOURCE_LABELS[source] }))} />
        </Form.Item>
        <Form.Item name="requestedQuantity" label="Quantity (e.g. number of trucks)">
          <InputNumber className="w-full" min={1} step={1} placeholder="1" />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="contactName" label="Who asked — name">
          <Input />
        </Form.Item>
        <Form.Item name="contactPhone" label="Who asked — phone">
          <Input />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="originZoneCode" label="Origin zone">
          <Select allowClear options={zones.map((z) => ({ value: z.code, label: z.name }))} showSearch optionFilterProp="label" />
        </Form.Item>
        <Form.Item name="destinationZoneCode" label="Destination zone">
          <Select allowClear options={zones.map((z) => ({ value: z.code, label: z.name }))} showSearch optionFilterProp="label" />
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <Form.Item name="requestedDate" label="Requested date">
          <DatePicker className="w-full" />
        </Form.Item>
        <Form.Item name="customerDeliveryDeadline" label="Customer delivery deadline">
          <DatePicker className="w-full" />
        </Form.Item>
      </div>
    </>
  );
}
